import { defineAdapter } from '@loop-coffee/commerce-contracts';

import { listCheckoutPaymentOptions, resolvePaymentAdapter } from './registry';

// Glue between the registry and the checkout payment slot (`payment` of CommerceProvider:
// `{ id, label, capabilities, prepare(cart) }`). Nothing here knows a provider by name.

/** Region payment options the storefront can present, in API order. */
export async function loadCheckoutPaymentOptions(client, regionId) {
  return listCheckoutPaymentOptions(await client.listPaymentProviders(regionId));
}

/**
 * Checkout payment slot for one provider of the registry. Only `flow: 'none'` is wired today:
 * redirect/embedded flows need their own step, so they fail here instead of placing an order
 * the customer never paid for.
 */
export function createCheckoutPaymentAdapter(client, providerId) {
  const found = resolvePaymentAdapter(providerId);
  if (!found) {
    throw new Error(`Payment provider ${providerId} is not supported by this storefront`);
  }
  if (found.flow !== 'none') {
    throw new Error(`Payment flow "${found.flow}" is not supported by checkout yet`);
  }
  return defineAdapter('payment', {
    id: found.id,
    label: found.label,
    description: found.description,
    flow: found.flow,
    capabilities: found.capabilities,
    testOnly: found.testOnly,
    prepare(cart) {
      return client.initiatePaymentSession(cart.id, found.id);
    },
  });
}
